import PropTypes from "prop-types"

export const ParagraphTypes = ["p1", "p2", "p3"]

export const BaseTypeProps = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  className: PropTypes.string,
  italic: PropTypes.bool,
}
